import copy from 'clipboard-copy';
var clipboardCopy = copy;
export default clipboardCopy;
